<cap-rubrik [isOpen]="true" class="externe-daten" id="rubrik-oereb">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Oereb" | translate }}</h2>
  </ng-container>
  <cap-oereb-table-alle></cap-oereb-table-alle>
</cap-rubrik>
